const AlertIcon = () => {
  return (
    <svg
      width='22'
      height='19'
      viewBox='0 0 22 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.3'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.62746 0.741696L0.409768 17.0861C0.113387 17.6116 0.305598 18.2743 0.839085 18.5663C1.00325 18.6561 1.18794 18.7033 1.37573 18.7033H20.7329C21.3432 18.7033 21.8379 18.2159 21.8379 17.6147C21.8379 17.4144 21.7818 17.218 21.6758 17.0471L11.5363 0.702718C11.2181 0.189738 10.538 0.0280176 10.0172 0.341506C9.8544 0.439518 9.72013 0.577389 9.62746 0.741696Z'
        fill='#F4A7B2'
      />
      <path
        d='M11.6534 6.72917C11.6534 6.12798 11.1587 5.64062 10.5484 5.64062C9.93809 5.64062 9.44336 6.12798 9.44336 6.72917V12.1719C9.44336 12.7731 9.93809 13.2604 10.5484 13.2604C11.1587 13.2604 11.6534 12.7731 11.6534 12.1719V6.72917Z'
        fill='white'
      />
      <path
        d='M11.6534 15.4382C11.6534 14.837 11.1587 14.3496 10.5484 14.3496C9.93809 14.3496 9.44336 14.837 9.44336 15.4382C9.44336 16.0393 9.93809 16.5267 10.5484 16.5267C11.1587 16.5267 11.6534 16.0393 11.6534 15.4382Z'
        fill='white'
      />
    </svg>
  )
}

export { AlertIcon }
